import BigNumber from 'bignumber.js';
import { toPrecision, scientificNotationToString } from '../../utils/numbers';
import { useIntl } from 'react-intl';
import { TokenMetadata } from '../ft-contract';

export const DEFAULTSELECTEDFEE = 2000;

export const FEELIST = [
  {
    fee: 100,
    text: 'Best for very stable pairs',
  },
  {
    fee: 400,
    text: 'Best for stable pairs',
  },
  {
    fee: 2000,
    text: 'Best for most pairs',
  },
  {
    fee: 10000,
    text: 'Best for rare pairs',
  },
];

export function displayNumberToAppropriateDecimals(value: string | number) {
  if (!value) return value;
  const numBig = new BigNumber(value);
  if (numBig.isEqualTo(0)) return 0;
  if (numBig.isLessThan(0.01)) {
    return toPrecision(scientificNotationToString(value.toString()), 5);
  } else if (numBig.isGreaterThanOrEqualTo(0.01) && numBig.isLessThan(1)) {
    return toPrecision(scientificNotationToString(value.toString()), 3);
  } else if (numBig.isGreaterThanOrEqualTo(1) && numBig.isLessThan(10000)) {
    return toPrecision(scientificNotationToString(value.toString()), 2);
  } else {
    return toPrecision(scientificNotationToString(value.toString()), 0);
  }
}

export const TOKEN_LIST_FOR_RATE = [
  'USDC.e',
  'USDC',
  'USDT.e',
  'USDT',
  'DAI',
  'USDt',
];

const TOKEN_LIST_FOR_RATE_EXTRA = ['NEAR'];

export function pause_old_dcl_claim_tip() {
  const intl = useIntl();

  const tip = intl.formatMessage({
    id: 'remove_will_automatically_claim',
    defaultMessage: 'Removing will automatically claim your unclaimed fees.',
  });

  let result: string = `<div class="opacity-50 w-p200 text-xs text-left">${tip}</div>`;
  return result;
}

export function sort_tokens_by_base(tokens: TokenMetadata[]) {
  const tokens_temp = JSON.parse(JSON.stringify(tokens || []));
  tokens_temp.sort((tokenB: TokenMetadata, tokenA: TokenMetadata) => {
    if (TOKEN_LIST_FOR_RATE_EXTRA.indexOf(tokenB.symbol) > -1) return 1;
    if (TOKEN_LIST_FOR_RATE_EXTRA.indexOf(tokenA.symbol) > -1) return -1;
    return 0;
  });
  tokens_temp.sort((tokenB: TokenMetadata, tokenA: TokenMetadata) => {
    if (TOKEN_LIST_FOR_RATE.indexOf(tokenB.symbol) > -1) return 1;
    if (TOKEN_LIST_FOR_RATE.indexOf(tokenA.symbol) > -1) return -1;
    return 0;
  });
  return tokens_temp;
}
